var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Button, DropdownDivider, DropdownHeader, Grid, Icon, Input, Menu, Select } from "semantic-ui-react";
import { DetectOnly, ProbeDetect, ProbeOnly } from "../../KitDeserializer";
import { getWithAuthn, postJsonWithAuthn } from "../../RequestHelpers";
import { isPredictedTarget, targetHasMIValidatedEntry } from "../KitToFormStateUtilityFunctions";
import { PriceDisplay } from "../rna-fish/EditKitForm";
import { abbreviateRnaWithModal } from "../rna-fish/KitDisplay";
import { RnaCishKitPrice, } from "../rna-fish/KitModel";
import { ErrorElements } from "../rna-fish/NewRnaFishKitPage";
import { uniqueBy } from "../rna-fish/ProbeSetForm";
import { miValidatedIcon, RnaCishEditableOrganism, RnaCishEditableTarget } from "./ProbeSetForm";
import { HcrAmplifier } from "./RnaCatalog";
var ProKitForm = /** @class */ (function (_super) {
    __extends(ProKitForm, _super);
    function ProKitForm(props) {
        var _this = _super.call(this, props) || this;
        _this.debounceSearchQueryChange = debounce(function (event, data) {
            _this.onSearchQueryChange(event, data);
        }, 500);
        _this.onSearchChange = function (event, data) {
            if (_this.props.formState.organism.id !== -1 && data.searchQuery.length !== 0) {
                // Set the form state immediately
                _this.props.setFormState(function () { return ({ enableCustomTarget: false }); });
                // Call the debounced function
                _this.debounceSearchQueryChange(event, data);
            }
        };
        _this.onProtocolChange = function (_, data) {
            var pt = data.tabIndex;
            var selectedProtocol = _this.props.catalog.cishProtocols.find(function (p) {
                return p.id === pt;
            });
            var selectedEnzyme = _this.props.catalog.cishAmplifier
                .amplifierConfig
                .find(function (c) {
                var _a, _b;
                return c.protocolType.id === (selectedProtocol === null || selectedProtocol === void 0 ? void 0 : selectedProtocol.id) &&
                    c.displayName.trim() === ((_b = (_a = _this.props.formState.enzymeCompatibility) === null || _a === void 0 ? void 0 : _a.displayName) === null || _b === void 0 ? void 0 : _b.trim());
            });
            if (!_this.checkChromogenCompatibility(_this.props.formState.chromogen, selectedProtocol, selectedEnzyme)) {
                _this.props.setFormState(function () { return ({
                    chromogen: undefined
                }); }, _this.loadPrice);
            }
            _this.props.setFormState(function () { return ({
                protocolType: selectedProtocol,
                enzymeCompatibility: selectedEnzyme
            }); }, _this.loadPrice);
        };
        _this.predictedOrVerifiedLabel = function (target) {
            if (target.predictedTarget) {
                return React.createElement("div", { style: { paddingTop: '0.5rem' } },
                    React.createElement(Icon, { name: 'circle', color: 'yellow' }),
                    React.createElement("a", { target: "_blank", href: "https://www.ncbi.nlm.nih.gov/books/NBK50679/#RefSeqFAQ.what_is_the_difference_between" }, "Predicted Sequence from NCBI"));
            }
            else {
                return React.createElement("div", { style: { paddingTop: '0.5rem' } },
                    React.createElement(Icon, { name: 'circle', color: 'green' }),
                    React.createElement("a", { target: "_blank", href: "https://www.ncbi.nlm.nih.gov/books/NBK50679/#RefSeqFAQ.what_is_the_difference_between" }, "Verified Sequence from NCBI"));
            }
        };
        // unicode of dna is U+1F9EC
        _this.shortSequenceWarning = function () {
            return React.createElement("div", { style: { paddingTop: '0.5rem' } }, "\uD83E\uDDEC The sequence you entered is shorter than 600 nt. If you proceed, a member of our Design Team will review the proposed design with you before production begins.");
        };
        _this.noSequenceMessage = function () {
            return React.createElement("div", { style: { paddingTop: '0.5rem' } }, "\uD83E\uDDEC Don\u2019t have the sequence handy? You can place your order and submit the target sequence later.");
        };
        _this.enzymeLabels = function (config, selected) {
            if (config.antiHapten2Ap.id !== "NONE" && config.antiHapten2Hrp.id !== "NONE") {
                return React.createElement(React.Fragment, null,
                    React.createElement("p", { className: selected ? 'ish-sec-p-tag selected-ish' : 'ish-sec-p-tag' }, "(+$15/slide)"));
            }
            else if (config.antiHapten2Ap.id !== "NONE" && config.antiHapten2Hrp.id === "NONE") {
                return React.createElement(React.Fragment, null,
                    React.createElement("p", { className: selected ? 'ish-sec-p-tag selected-ish' : 'ish-sec-p-tag' }, "(e.g., Fast Red)"));
            }
            else if (config.antiHapten2Ap.id === "NONE" && config.antiHapten2Hrp.id !== "NONE") {
                return React.createElement(React.Fragment, null,
                    React.createElement("p", { className: selected ? 'ish-sec-p-tag selected-ish' : 'ish-sec-p-tag' }, "(e.g., DAB, TSA Fluors)"));
            }
            else {
                return React.createElement(React.Fragment, null);
            }
        };
        _this.onConfigurationChange = function (_, data) {
            var index = data.index;
            var kitConfiguration = _this.props.kitConfigurations[index];
            _this.props.setFormState(function () {
                return {
                    kitConfiguration: kitConfiguration
                };
            }, _this.loadPrice);
        };
        _this.onScaleChange = function (_, data) {
            var scale = data.tabIndex;
            var selectedScale = _this.props.catalog.probeSet.catalog.cishScale.find(function (s) { return s === scale; });
            _this.props.setFormState(function () { return ({
                scale: selectedScale
            }); }, _this.loadPrice);
        };
        _this.onEnzymeCompatibilityChange = function (_, data) {
            var cc = data.tabIndex;
            var selectedEnzyme = _this.props.catalog.cishAmplifier.amplifierConfig
                .filter(function (c) {
                var _a;
                if (_this.props.formState.protocolType != null) {
                    return c.protocolType.id === ((_a = _this.props.formState.protocolType) === null || _a === void 0 ? void 0 : _a.id);
                }
                else {
                    return true;
                }
            })
                .find(function (c) { return c.id === cc; });
            if (!_this.checkChromogenCompatibility(_this.props.formState.chromogen, _this.props.formState.protocolType, selectedEnzyme)) {
                _this.props.setFormState(function () { return ({
                    chromogen: undefined
                }); }, _this.loadPrice);
            }
            _this.props.setFormState(function () { return ({
                enzymeCompatibility: selectedEnzyme
            }); }, _this.loadPrice);
        };
        _this.onChromogenChange = function (_, data) {
            var cc = data.tabIndex;
            if (cc === 'NONE') {
                _this.props.setFormState(function () { return ({
                    chromogen: {
                        id: 'NONE',
                        label: 'NONE',
                        enzymeCompatibility: '',
                        bufferCompatibility: { id: 'NONE', label: 'NONE' },
                        protocolCompatibility: []
                    }
                }); }, _this.loadPrice);
            }
            else {
                var selectedChromogen_1 = _this.props.catalog.cishChromogens.chromogens
                    .filter(function (c) {
                    return _this.checkChromogenCompatibility(c, _this.props.formState.protocolType, _this.props.formState.enzymeCompatibility);
                })
                    .find(function (c) { return c.id === cc; });
                _this.props.setFormState(function () { return ({
                    chromogen: selectedChromogen_1
                }); }, _this.loadPrice);
            }
        };
        _this.checkChromogenCompatibility = function (chromogen, protocol, enzyme) {
            if (chromogen == null || protocol == null || enzyme == null) {
                return false;
            }
            else {
                return chromogen.protocolCompatibility.some(function (p) { return p.id === protocol.id; }) &&
                    (enzyme.displayName === "HRP & AP" || enzyme.displayName === chromogen.enzymeCompatibility);
            }
        };
        _this.onOrganismChange = function (_, data) {
            var organism = data.value;
            var selectedOrganism = _this.props.catalog.probeSet.catalog.organisms.find(function (o) { return o.id === organism; });
            _this.props.setFormState(function () {
                return {
                    organism: selectedOrganism ? RnaCishEditableOrganism.fromLibOrg(selectedOrganism) : RnaCishEditableOrganism.default(),
                    target: RnaCishEditableTarget.default(-1),
                    targets: [],
                    searchQuery: ""
                };
            }, _this.loadPrice);
        };
        _this.onTargetChange = function (_, data) {
            if (typeof data.value === "number") {
                _this.props.setFormState(function () { return ({
                    searchLoading: true
                }); }, function () {
                    getWithAuthn("/rna/search/probeSetFamilyId/" + encodeURIComponent(data.value))
                        .then(function (resp) {
                        if (resp.status === 200) {
                            return resp.json();
                        }
                        else {
                            return undefined;
                        }
                    })
                        .then(function (jsonFamily) {
                        if (jsonFamily !== undefined && jsonFamily.psf != null) {
                            _this.props.setFormState(function () {
                                var _a;
                                var target = jsonFamily.psf;
                                var accession = (_a = target.defaultVariant.accession) === null || _a === void 0 ? void 0 : _a.transcriptAccession;
                                return {
                                    searchLoading: false,
                                    target: new RnaCishEditableTarget(target.geneSymbol, target.description, accession ? accession : "", target.defaultVariant.targetMrnaSeq, target.defaultVariant.probeSetSize, target.id, targetHasMIValidatedEntry(target), isPredictedTarget(target), undefined
                                    // target.defaultVariant.id
                                    )
                                };
                            }, _this.loadPrice);
                        }
                        else {
                            _this.props.setFormState(function () {
                                return {
                                    searchLoading: false,
                                    target: RnaCishEditableTarget.default(-1),
                                    probeSetFamilies: [],
                                    searchQuery: ""
                                };
                            }, _this.loadPrice);
                        }
                    });
                });
            }
            else {
                _this.props.setFormState(function () {
                    return {
                        searchLoading: false,
                        probeSetFamily: undefined,
                        target: undefined,
                        searchQuery: "",
                        probeSetFamilies: [],
                    };
                }, _this.loadPrice);
            }
        };
        _this.onAddCustomOrganism = function (_, data) {
            var ct = data.value;
            _this.props.setFormState(function () { return ({
                organism: new RnaCishEditableOrganism(ct, "", -1)
            }); }, _this.loadPrice);
        };
        _this.onAddCustomTarget = function (_, data) {
            var ct = data.value;
            _this.props.setFormState(function () { return ({
                probeSetFamily: undefined,
                target: new RnaCishEditableTarget(ct, "", "", "", 20, -1, false, false, undefined)
            }); }, _this.loadPrice);
        };
        _this.effectiveOrganisms = function () {
            var organisms = _this.props.catalog.probeSet.catalog.organisms.map(function (o) {
                return {
                    text: o.name + " " + (o.scientificName.length > 0 ? '(' + o.scientificName + ')' : ''),
                    content: o.name + " " + (o.scientificName.length > 0 ? '(' + o.scientificName + ')' : ''),
                    value: o.id
                };
            });
            if (_this.props.formState.organism.id === -1 && _this.props.formState.organism.name.trim() !== "") {
                organisms = organisms.concat([
                    {
                        text: _this.props.formState.organism.name,
                        content: _this.props.formState.organism.name,
                        value: _this.props.formState.organism.id
                    }
                ]);
            }
            return uniqueBy(organisms, function (o) { return o.value; });
        };
        _this.effectiveTargets = function () {
            var exactMatchFamilies = _this.props.formState.probeSetFamilies.filter(function (psf) {
                return _this.searchQueryIsExactMatchToProbeSetFamily(psf, _this.props.formState.searchQuery);
            });
            var synonymFamilies = _this.props.formState.probeSetFamilies.filter(function (psf) {
                return _this.searchQueryIsSynonymForProbeSetFamily(psf, _this.props.formState.searchQuery);
            });
            var otherProbeSetFamilies = _this.props.formState.probeSetFamilies.filter(function (psf) {
                return !_this.searchQueryIsSynonymForProbeSetFamily(psf, _this.props.formState.searchQuery) &&
                    !_this.searchQueryIsExactMatchToProbeSetFamily(psf, _this.props.formState.searchQuery);
            });
            var options = [];
            options = options.concat((exactMatchFamilies.length > 0 || synonymFamilies.length > 0) ? [
                React.createElement(DropdownHeader, { key: 'recommended-header', content: 'Recommended' }),
                React.createElement(DropdownDivider, { key: 'recommended-divider' })
            ] : []).concat(exactMatchFamilies.map(function (f) {
                var symAndDes = React.createElement(React.Fragment, null,
                    f.geneSymbol,
                    " ",
                    React.createElement("em", null, f.description.length > 0 ? '(' + f.description + ')' : ''));
                var text = _this.probeSetFamilyHasMIValidatedEntry(f) ?
                    React.createElement(React.Fragment, null,
                        React.createElement(Icon, { name: miValidatedIcon }),
                        symAndDes)
                    : symAndDes;
                return {
                    content: symAndDes,
                    className: f.geneSymbol,
                    text: text,
                    value: f.id
                };
            })).concat(synonymFamilies.map(function (f) {
                var symAndDes = React.createElement(React.Fragment, null,
                    f.geneSymbol,
                    " ",
                    React.createElement("em", null, f.description.length > 0 ? '(' + f.description + ')' : ''));
                var text = _this.probeSetFamilyHasMIValidatedEntry(f) ?
                    React.createElement(React.Fragment, null,
                        React.createElement(Icon, { name: miValidatedIcon }),
                        symAndDes)
                    : symAndDes;
                return {
                    content: symAndDes,
                    className: f.geneSymbol,
                    text: text,
                    value: f.id
                };
            })).concat((otherProbeSetFamilies.length !== 0 && _this.props.formState.searchQuery !== '') ? [
                React.createElement(DropdownHeader, { key: 'other-header', content: "Other Results for " + _this.props.formState.searchQuery }),
                React.createElement(DropdownDivider, { key: 'other-divider' })
            ]
                : []).concat(otherProbeSetFamilies.map(function (f) {
                var symAndDes = React.createElement(React.Fragment, null,
                    f.geneSymbol,
                    " ",
                    React.createElement("em", null, f.description.length > 0 ? '(' + f.description + ')' : ''));
                var text = _this.probeSetFamilyHasMIValidatedEntry(f) ?
                    React.createElement(React.Fragment, null,
                        React.createElement(Icon, { name: miValidatedIcon }),
                        symAndDes)
                    : symAndDes;
                return {
                    content: symAndDes,
                    className: f.geneSymbol,
                    text: text,
                    value: f.id
                };
            })).concat(!_this.noTargetSelected() ? [
                {
                    text: _this.props.formState.target.name,
                    value: -1
                }
            ] : []);
            return options;
        };
        _this.noOrganismSelected = function () {
            var organism = _this.props.formState.organism;
            return organism.id === -1 && organism.name.trim() === "";
        };
        _this.noTargetSelected = function () {
            var target = _this.props.formState.target;
            return target.id === -1 && target.name.trim() === "";
        };
        _this.searchQueryIsSynonymForProbeSetFamily = function (f, searchQuery) {
            return !!f.synonyms.find(function (s) { return s.toLowerCase() === searchQuery.toLowerCase(); });
        };
        _this.searchQueryIsExactMatchToProbeSetFamily = function (f, searchQuery) {
            return f.geneSymbol.toLowerCase() === searchQuery.toLowerCase();
        };
        _this.probeSetFamilyHasMIValidatedEntry = function (f) {
            if (_this.props.formState.target.id === f.id) {
                return _this.props.formState.target.miValidated;
            }
            else {
                return false;
            }
        };
        _this.onSearch = function (options, value) {
            if (value.trim().length === 0) {
                return [];
            }
            else {
                return uniqueBy(options, function (o) { return o.value; });
            }
        };
        _this.onSearchQueryChange = function (_, data) {
            var path = "";
            if (_this.props.formState.organism.id === -1 || data.searchQuery.length === 0) {
                _this.props.setFormState(function () { return ({
                    probeSetFamilies: [],
                    probeSetFamily: undefined,
                    searchQuery: "",
                    target: data.searchQuery.length === 0 ? undefined : _this.props.formState.target
                }); });
                return;
            }
            path = "/rna/search/id/" +
                (encodeURIComponent(_this.props.formState.organism.id) + "/targetGene/") +
                ("" + encodeURIComponent(data.searchQuery));
            _this.props.setFormState(function () { return ({
                searchLoading: true
            }); }, function () {
                getWithAuthn(path)
                    .then(function (resp) {
                    if (resp.status === 200) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    _this.props.setFormState(function () {
                        if (resp !== undefined) {
                            return {
                                searchLoading: false,
                                enableCustomTarget: true,
                                searchQuery: data.searchQuery,
                                probeSetFamilies: resp.probeSetFamilyResults,
                                probeSetFamily: undefined
                            };
                        }
                        else {
                            return {
                                searchLoading: false,
                                enableCustomTarget: true,
                                probeSetFamily: undefined,
                                searchQuery: data.searchQuery
                            };
                        }
                    }, _this.loadPrice);
                });
            });
        };
        _this.onRnaChange = function (_, data) {
            _this.props.setFormState(function () {
                var _a;
                return {
                    target: (_a = _this.props.formState.target) === null || _a === void 0 ? void 0 : _a.withRna(cleanUpIshRnaSeq(data.value))
                };
            });
        };
        // TODO remove hardcoded prices when this is called
        _this.loadPrice = function () {
            _this.props.setFormState(function () { return ({
                priceLoading: true
            }); }, function (newState) {
                postJsonWithAuthn(_this.props.kitPriceUrlPath, JSON.stringify(ProKitForm.serializeProKit(newState)))
                    .then(function (resp) {
                    if (resp.status === 400) {
                        return resp.json().then(function (json) { return new ErrorElements(json.errors); });
                    }
                    return resp.json();
                }).then(function (resp) {
                    if (resp instanceof ErrorElements) {
                        var formState = _this.props.formState;
                        var price_1;
                        if (formState.protocolType != null && formState.scale != null && formState.kitConfiguration != null) {
                            var subtotal = void 0;
                            if (formState.kitConfiguration === ProbeOnly) {
                                if (formState.scale === 20) {
                                    subtotal = 100000;
                                }
                                else {
                                    subtotal = 400000;
                                }
                            }
                            else if (formState.kitConfiguration === DetectOnly) {
                                if (formState.scale === 20) {
                                    subtotal = 100000;
                                }
                                else {
                                    subtotal = 400000;
                                }
                                if (formState.enzymeCompatibility != null
                                    && formState.enzymeCompatibility.antiHapten2Ap.id !== "NONE"
                                    && formState.enzymeCompatibility.antiHapten2Hrp.id !== "NONE") {
                                    subtotal = subtotal + (formState.scale * 1500);
                                }
                            }
                            else {
                                if (formState.scale === 20) {
                                    subtotal = 150000;
                                }
                                else {
                                    subtotal = 675000;
                                }
                                if (formState.enzymeCompatibility != null
                                    && formState.enzymeCompatibility.antiHapten2Ap.id !== "NONE"
                                    && formState.enzymeCompatibility.antiHapten2Hrp.id !== "NONE") {
                                    subtotal = subtotal + (formState.scale * 1500);
                                }
                                if (formState.chromogen != null && formState.chromogen.id !== "NONE") {
                                    subtotal = subtotal + (formState.scale * 2000);
                                }
                            }
                            price_1 = {
                                kitPrice: new RnaCishKitPrice(0, false, 0, false, 0, false, 0, false, 0, false, subtotal),
                                listPriceCents: subtotal,
                                discountCents: 0,
                            };
                        }
                        _this.props.setFormState(function () { return ({
                            errors: resp.errors,
                            priceLoading: false,
                            price: price_1
                        }); });
                    }
                    else {
                        _this.props.setFormState(function () { return ({
                            errors: [],
                            price: resp,
                            priceLoading: false
                        }); });
                    }
                }).catch(function (rej) {
                    console.error("Couldn't update price: " + rej);
                });
            });
        };
        return _this;
    }
    ProKitForm.prototype.componentDidMount = function () {
        if (this.props.loadPriceOnMount) {
            this.loadPrice();
        }
    };
    ProKitForm.prototype.render = function () {
        var _this = this;
        // Prop variables
        var kitConfigurations = this.props.kitConfigurations;
        var protocols = this.props.catalog.cishProtocols;
        // Form state variables
        var kitConfiguration = this.props.formState.kitConfiguration;
        var protocolType = this.props.formState.protocolType;
        var organism = this.props.formState.organism;
        var target = this.props.formState.target;
        var chromogen = this.props.formState.chromogen;
        var scale = this.props.formState.scale;
        var enzymeCompatibility = this.props.formState.enzymeCompatibility;
        var ampCatalog = this.props.catalog.cishAmplifier;
        var enzymes;
        if (protocolType != null) {
            enzymes = ampCatalog
                .amplifierConfig
                .filter(function (c) { return c.protocolType.id === protocolType.id; });
        }
        else {
            // If the protocol type is not selected show the leica configurations as the default until the user
            // selects a protocol type
            enzymes = ampCatalog
                .amplifierConfig
                .filter(function (c) { return c.protocolType.id === "LEICA"; });
        }
        return React.createElement(React.Fragment, null,
            React.createElement(Grid, { columns: 2, verticalAlign: "middle" },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 3 }),
                    React.createElement(Grid.Column, { textAlign: "center", width: 12 },
                        React.createElement("h1", { className: "ish-primary-header" }, "HCR\u2122 Kit Designer"),
                        React.createElement("h1", { className: "ish-subheader" }, "Build your RNA-ISH Kit")))),
            React.createElement(Grid, { columns: 4, verticalAlign: "middle" },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 3, textAlign: "right" },
                        React.createElement("p", { className: "ish-subheader-tag" }, "Configuration")),
                    React.createElement(Grid.Column, { width: 12, textAlign: "center" },
                        React.createElement(Menu, { compact: true, widths: 12, className: 'outer-config-box', borderless: true }, kitConfigurations.map(function (bc, index) {
                            return React.createElement(React.Fragment, { key: index },
                                bc === ProbeDetect && React.createElement(Menu.Item, { className: kitConfiguration === bc ?
                                        "configure-selection selected-ish" : "configure-selection", onClick: _this.onConfigurationChange, index: index, fitted: true, active: kitConfiguration === bc },
                                    React.createElement("p", { className: kitConfiguration === bc ? "ish-p-tag selected-ish" : "ish-p-tag" },
                                        "Probe + Detect",
                                        React.createElement("br", null),
                                        "Kit")),
                                bc === ProbeOnly && React.createElement(Menu.Item, { className: kitConfiguration === bc ?
                                        "configure-selection selected-ish" : "configure-selection", onClick: _this.onConfigurationChange, index: index, fitted: true, active: kitConfiguration === bc },
                                    React.createElement("p", { className: kitConfiguration === bc ? "ish-p-tag selected-ish" : "ish-p-tag" },
                                        "Probe",
                                        React.createElement("br", null),
                                        "Only")),
                                bc === DetectOnly && React.createElement(Menu.Item, { className: kitConfiguration === bc ? "configure-selection selected-ish" : "configure-selection", onClick: _this.onConfigurationChange, index: index, fitted: true, active: kitConfiguration === bc },
                                    React.createElement("p", { className: kitConfiguration === bc ? "ish-p-tag selected-ish" : "ish-p-tag" },
                                        "Detect",
                                        React.createElement("br", null),
                                        "Only")));
                        })))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 3, textAlign: "right" },
                        React.createElement("p", { className: 'ish-subheader-tag' }, "Platform")),
                    protocols.filter(function (p) { return p.id !== 'MANUAL'; }).map(function (p, index) {
                        return React.createElement(React.Fragment, { key: index },
                            React.createElement(Grid.Column, { width: 4, key: index, textAlign: "right" },
                                React.createElement(Button, { className: (p.id === (protocolType === null || protocolType === void 0 ? void 0 : protocolType.id)) ? "button-box selected-ish" : "button-box", tabIndex: p.id, onClick: _this.onProtocolChange },
                                    React.createElement("p", { className: (protocolType === null || protocolType === void 0 ? void 0 : protocolType.id) === p.id ? 'ish-p-tag selected-ish' : 'ish-p-tag' }, p.alias === "ONCORE Pro X" ? React.createElement(React.Fragment, null, "ONCORE Pro\u00A0X") : p.alias))));
                    })),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 3, textAlign: "right" },
                        React.createElement("p", { className: 'ish-subheader-tag' }, "Scale")),
                    ampCatalog.amplifierScales.map(function (s, index) {
                        return React.createElement(React.Fragment, { key: index },
                            React.createElement(Grid.Column, { width: 6, key: index, textAlign: "right" },
                                React.createElement(Button, { className: scale === s ? "button-box selected-ish" : "button-box", tabIndex: s, onClick: _this.onScaleChange },
                                    React.createElement("p", { className: scale === s ? 'ish-p-tag selected-ish' : 'ish-p-tag' },
                                        s,
                                        " Slides"))));
                    }))),
            React.createElement(Grid, { className: (kitConfiguration === DetectOnly || kitConfiguration == null) ? "disabled" : "", columns: 2 },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 3, textAlign: "right" },
                        React.createElement("h1", { className: "ish-secondary-header" }, "Probe")))),
            React.createElement(Grid, { className: (kitConfiguration === DetectOnly || kitConfiguration == null) ? "disabled" : "", columns: 2, verticalAlign: "middle" },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 3, textAlign: "right" },
                        React.createElement("p", { className: 'ish-subheader-tag' }, "Organism")),
                    React.createElement(Grid.Column, { width: 12 },
                        React.createElement(Select, { className: (organism.id !== -1 && organism.name.trim() !== "") ?
                                'selection-box selected-ish' : "selection-box", placeholder: 'Type-in or select a organism.', options: this.effectiveOrganisms(), onChange: this.onOrganismChange, search: true, allowAdditions: true, additionLabel: 'Custom Organism: ', additionPosition: "bottom", icon: false, onAddItem: this.onAddCustomOrganism, clearable: true, selectOnBlur: false, selectOnNavigation: false, value: this.noOrganismSelected() ? "" : organism.id }))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 3, textAlign: "right" },
                        React.createElement("p", { className: 'ish-subheader-tag' }, "Target")),
                    React.createElement(Grid.Column, { width: 12 },
                        React.createElement(Select, { additionLabel: "Custom Target: ", additionPosition: "bottom", allowAdditions: this.props.formState.enableCustomTarget, className: !this.noTargetSelected() ? 'selection-box selected-ish' : "selection-box", clearable: true, disabled: this.noOrganismSelected(), loading: this.props.formState.searchLoading, onAddItem: this.onAddCustomTarget, onChange: this.onTargetChange, onSearchChange: this.onSearchChange, selectOnBlur: false, selectOnNavigation: false, options: this.noOrganismSelected() ? [] : this.effectiveTargets(), placeholder: 'Type to search for a target.', search: this.onSearch, spellCheck: false, value: this.noTargetSelected() ? "" : target.id }))),
                this.props.formState.target.id !== -1 &&
                    React.createElement(Grid.Row, { className: "sequence-info" },
                        React.createElement(Grid.Column, { width: 3 }),
                        React.createElement(Grid.Column, { width: 12 }, this.predictedOrVerifiedLabel(this.props.formState.target))),
                target && React.createElement(React.Fragment, null,
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: 3, textAlign: "right" },
                            React.createElement("p", { className: 'ish-subheader-tag' }, "Sequence")),
                        React.createElement(Grid.Column, { width: 12 },
                            React.createElement(Input, { className: target.targetMrnaSeq.length > 0 ? 'selection-box selected-ish' : "selection-box", placeholder: 'RNA Target Sequence', onChange: this.onRnaChange, value: target ? target.targetMrnaSeq : "" }))),
                    React.createElement(Grid.Row, { className: 'sequence-info' },
                        React.createElement(Grid.Column, { width: 3 }),
                        React.createElement(Grid.Column, { width: 12 },
                            React.createElement("label", { htmlFor: "rna-target-seq" },
                                "RNA Target Sequence ", "(" + target.targetMrnaSeq.length + " nt)",
                                ": ",
                                target.targetMrnaSeq.length > 0 && abbreviateRnaWithModal(target.targetMrnaSeq, true)),
                            (target.targetMrnaSeq.length > 0 && target.targetMrnaSeq.length < 600) && this.shortSequenceWarning(),
                            (target.targetMrnaSeq.length === 0) && this.noSequenceMessage())))),
            React.createElement(Grid, { className: (kitConfiguration === ProbeOnly || kitConfiguration == null) ? "disabled" : "", columns: 2 },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 3, textAlign: "right" },
                        React.createElement("h1", { className: 'ish-secondary-header' }, "Detect")))),
            React.createElement(Grid, { className: (kitConfiguration === ProbeOnly || kitConfiguration == null) ? "disabled" : "", columns: 4, verticalAlign: "middle", textAlign: "center", padded: false },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 3, textAlign: "right" },
                        React.createElement("p", { className: 'ish-subheader-tag' }, "Enzyme")),
                    enzymes.sort(function (c) {
                        if (c.displayName === "HRP") {
                            return -1;
                        }
                        else if (c.displayName === "AP") {
                            return 0;
                        }
                        else {
                            return 1;
                        }
                    }).map(function (c, index) {
                        return React.createElement(Grid.Column, { key: index, width: 4 },
                            React.createElement(Button, { className: (enzymeCompatibility === null || enzymeCompatibility === void 0 ? void 0 : enzymeCompatibility.id) === c.id ? "button-box selected-ish" : "button-box", tabIndex: c.id, onClick: _this.onEnzymeCompatibilityChange },
                                React.createElement("p", { className: enzymeCompatibility === c ? 'ish-p-tag selected-ish' : 'ish-p-tag' }, c.displayName),
                                _this.enzymeLabels(c, enzymeCompatibility === c)));
                    }),
                    React.createElement(Grid.Column, { width: 1 }))),
            ((kitConfiguration === ProbeDetect || kitConfiguration === DetectOnly) &&
                ((protocolType === null || protocolType === void 0 ? void 0 : protocolType.id) === 'LEICA' || (protocolType === null || protocolType === void 0 ? void 0 : protocolType.id) === 'ONCORE_PRO_X') && enzymeCompatibility !== undefined) &&
                React.createElement(React.Fragment, null,
                    React.createElement(Grid, { columns: 2 },
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: 3, textAlign: "right" },
                                React.createElement("h1", { className: 'ish-secondary-header' }, "Extras")))),
                    React.createElement(Grid, { columns: 5, verticalAlign: "middle", textAlign: "center", padded: false },
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: 3, textAlign: "right" },
                                React.createElement("p", { className: 'ish-subheader-tag' }, "Chromogen"),
                                React.createElement("p", { className: 'ish-sec-p-tag' }, "(+$20/slide)")),
                            this.props.catalog.cishChromogens.chromogens.map(function (c, index) {
                                return React.createElement(Grid.Column, { key: index, width: 3 },
                                    React.createElement(Button, { className: _this.checkChromogenCompatibility(c, protocolType, enzymeCompatibility) ? ((chromogen === null || chromogen === void 0 ? void 0 : chromogen.id) === c.id ? "button-box selected-ish" : "button-box") : "button-box disabled", tabIndex: c.id, onClick: _this.onChromogenChange },
                                        React.createElement("p", { className: _this.checkChromogenCompatibility(c, protocolType, enzymeCompatibility) ? ((chromogen === null || chromogen === void 0 ? void 0 : chromogen.id) === c.id ? "ish-p-tag selected-ish" : "ish-p-tag") : "ish-p-tag disabled" }, c.label),
                                        React.createElement("p", { className: _this.checkChromogenCompatibility(c, protocolType, enzymeCompatibility) ? ((chromogen === null || chromogen === void 0 ? void 0 : chromogen.id) === c.id ? "ish-sec-p-tag selected-ish" : "ish-sec-p-tag") : "ish-sec-p-tag disabled" }, "(" + c.enzymeCompatibility + " compatible)")));
                            }),
                            React.createElement(Grid.Column, { key: 3, width: 3 },
                                React.createElement(Button, { className: (chromogen === null || chromogen === void 0 ? void 0 : chromogen.id) === 'NONE' ? "button-box selected-ish" : "button-box", tabIndex: 'NONE', onClick: this.onChromogenChange },
                                    React.createElement("p", { className: (chromogen === null || chromogen === void 0 ? void 0 : chromogen.id) === 'NONE' ? "ish-p-tag selected-ish" : "ish-p-tag" }, "None"))),
                            React.createElement(Grid.Column, { width: 1 })))),
            React.createElement(Grid, { columns: 4, textAlign: "right" },
                React.createElement(Grid.Row, null,
                    React.createElement("br", null)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 3 }),
                    React.createElement(Grid.Column, { width: 12 },
                        React.createElement("div", { 
                            // apply padding that matches the kit component div padding
                            style: { 'paddingRight': '.5rem' } },
                            React.createElement(PriceDisplay, { loading: this.props.formState.priceLoading, priceCents: this.props.formState.price ? this.props.formState.price.kitPrice.subtotalCents : undefined }))))));
    };
    ProKitForm.serializeProKit = function (state) {
        var _a, _b, _c, _d, _e;
        var kitConfig = state.kitConfiguration;
        var organism = state.organism;
        var target = state.target;
        var enzymeCompatibility = state.enzymeCompatibility;
        var hcrAmplifier = state.enzymeCompatibility ? state.enzymeCompatibility.amplifier : new HcrAmplifier("X4");
        var chromogen = state.chromogen;
        var scale = state.scale;
        var kit = {
            protocolType: (_a = state.protocolType) === null || _a === void 0 ? void 0 : _a.id,
            config: kitConfig,
            comment: state.comment
        };
        if (kitConfig === ProbeDetect) {
            kit.probeSetComponent = ProKitForm.serializeProbeSet(hcrAmplifier, organism, target, scale);
            kit.amplifierComponent = ProKitForm.serializeAmplifier(enzymeCompatibility, scale);
            kit.chromogenComponent = ProKitForm.serializeChromogen(chromogen, scale);
            var buffersComponent = {
                index: 1,
                amplificationBufferScaleSlides: scale,
                blockingSolutionScaleSlides: scale,
                endogenousEnzymeScaleSlides: scale,
                preHybridizationScaleSlides: 0,
                hrpQuencherScaleSlides: scale,
            };
            if (((_b = state.protocolType) === null || _b === void 0 ? void 0 : _b.id) === "LEICA") {
                buffersComponent = __assign(__assign({}, buffersComponent), { _type: "leica", bluingAgentScaleSlides: scale });
            }
            else if (((_c = state.protocolType) === null || _c === void 0 ? void 0 : _c.id) === "ONCORE_PRO_X") {
                buffersComponent = __assign(__assign({}, buffersComponent), { _type: "oncore", bluingAgentScaleSlides: scale });
            }
            else {
                buffersComponent = __assign(__assign({}, buffersComponent), { _type: "roche", antigenRetrievalScaleSlides: scale, dewaxScaleSlides: scale });
            }
            kit.buffersComponent = buffersComponent;
        }
        if (kitConfig === ProbeOnly) {
            kit.probeSetComponent = ProKitForm.serializeProbeSet(hcrAmplifier, organism, target, scale);
        }
        if (kitConfig === DetectOnly) {
            kit.amplifierComponent = ProKitForm.serializeAmplifier(enzymeCompatibility, scale);
            kit.chromogenComponent = ProKitForm.serializeChromogen(chromogen, scale);
            var buffersComponent = {
                index: 1,
                amplificationBufferScaleSlides: scale,
                blockingSolutionScaleSlides: scale,
                endogenousEnzymeScaleSlides: scale,
                preHybridizationScaleSlides: 0
            };
            if (((_d = state.protocolType) === null || _d === void 0 ? void 0 : _d.id) === "LEICA") {
                buffersComponent = __assign(__assign({}, buffersComponent), { _type: "leica", bluingAgentScaleSlides: scale, hrpQuencherScaleSlides: scale });
            }
            else if (((_e = state.protocolType) === null || _e === void 0 ? void 0 : _e.id) === "ONCORE_PRO_X") {
                buffersComponent = __assign(__assign({}, buffersComponent), { _type: "oncore", bluingAgentScaleSlides: scale, hrpQuencherScaleSlides: scale });
            }
            else {
                buffersComponent = __assign(__assign({}, buffersComponent), { _type: "roche", antigenRetrievalScaleSlides: scale, dewaxScaleSlides: scale });
            }
            kit.buffersComponent = buffersComponent;
        }
        return {
            _type: 'rna-cish',
            kit: kit
        };
    };
    // TODO should enzymeCompatibility be here?
    ProKitForm.serializeProbeSet = function (hcrAmplifier, organism, target, scale) {
        var probeSetComponent = {};
        // Catalog Probe Set
        if (target.variantId != null) {
            var variant = target.variantId;
            // Do nothing for now
            probeSetComponent = {
                _type: 'pro',
                index: 1,
                probeSet: {
                    _type: "uiCatalogInput",
                    hcrAmplifier: hcrAmplifier.id,
                    id: variant,
                    customerOrganismName: organism.displayName(),
                    customerTargetName: target.name,
                    customerAccessionNum: target.accession,
                    customerSequence: target.targetMrnaSeq,
                    customerProbeSetSize: target.probeSetSize
                },
                scaleSlides: scale,
                probeHybridizationAScaleSlides: scale,
                probeHybridizationBScaleSlides: scale
            };
        }
        // Library Organism Custom Target
        else if (organism.id !== -1) {
            probeSetComponent = {
                _type: 'pro',
                index: 1,
                probeSet: {
                    _type: "uiLibraryOrganismCustomTargetInput",
                    organism: {
                        id: organism.id
                    },
                    target: {
                        name: target.name,
                        accession: target.targetMrnaSeq === "" ? "Need target sequence or accession" : "",
                        targetMrnaSeq: target.targetMrnaSeq
                    },
                    hcrAmplifier: hcrAmplifier.id,
                    probeSetSize: target.probeSetSize
                },
                scaleSlides: scale,
                probeHybridizationAScaleSlides: scale,
                probeHybridizationBScaleSlides: scale
            };
        }
        // Other Organism Custom Target
        else {
            probeSetComponent = {
                _type: 'pro',
                index: 1,
                probeSet: {
                    _type: "uiOtherOrganismCustomTargetInput",
                    organism: {
                        name: organism.name
                    },
                    target: {
                        name: target.name,
                        accession: target.targetMrnaSeq === "" ? "Need target sequence or accession" : "",
                        targetMrnaSeq: target.targetMrnaSeq
                    },
                    hcrAmplifier: hcrAmplifier.id,
                    probeSetSize: target.probeSetSize
                },
                scaleSlides: scale,
                probeHybridizationAScaleSlides: scale,
                probeHybridizationBScaleSlides: scale
            };
        }
        return probeSetComponent;
    };
    ProKitForm.serializeAmplifier = function (enzymeCompatibility, amplifyScale) {
        var amplifierComponent = {
            _type: 'pro',
            index: 1,
            amplifierId: enzymeCompatibility ? enzymeCompatibility.amplifier.id : "NONE",
            haptenId: enzymeCompatibility ? enzymeCompatibility.hapten.id : "NONE",
            antiHapten1Id: enzymeCompatibility ? enzymeCompatibility.antiHapten1.id : "NONE",
            tyramideHaptenId: enzymeCompatibility ? enzymeCompatibility.tyramideHapten.id : "NONE",
            amplifierScaleSlides: amplifyScale,
            antiHapten1ScaleSlides: amplifyScale,
            tyramideHaptenScaleSlides: amplifyScale,
        };
        if ((enzymeCompatibility === null || enzymeCompatibility === void 0 ? void 0 : enzymeCompatibility.antiHapten2Ap.id) !== "NONE") {
            amplifierComponent = __assign(__assign({}, amplifierComponent), { antiHapten2ApId: enzymeCompatibility === null || enzymeCompatibility === void 0 ? void 0 : enzymeCompatibility.antiHapten2Ap.id, antiHapten2ApScaleSlides: amplifyScale });
        }
        if ((enzymeCompatibility === null || enzymeCompatibility === void 0 ? void 0 : enzymeCompatibility.antiHapten2Hrp.id) !== "NONE") {
            amplifierComponent = __assign(__assign({}, amplifierComponent), { antiHapten2HrpId: enzymeCompatibility === null || enzymeCompatibility === void 0 ? void 0 : enzymeCompatibility.antiHapten2Hrp.id, antiHapten2HrpScaleSlides: amplifyScale });
        }
        return amplifierComponent;
    };
    ProKitForm.serializeChromogen = function (chromogen, scale) {
        if (chromogen != null && chromogen.id !== 'NONE' && scale != null) {
            var chromogenComponent = {
                index: 1,
                chromogenId: chromogen.id,
                chromogenBufferId: chromogen.bufferCompatibility.id,
                chromogenScaleSlides: scale,
                chromogenBufferScaleSlides: scale,
                hematoxylinScaleSlides: scale
            };
            return chromogenComponent;
        }
        else {
            return null;
        }
    };
    return ProKitForm;
}(React.PureComponent));
export default ProKitForm;
export var debounce = function (fn, ms) {
    var timeoutId;
    return function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timeoutId);
        timeoutId = setTimeout(function () { return fn.apply(_this, args); }, ms);
    };
};
export var cleanUpIshRnaSeq = function (s) {
    return s.toUpperCase()
        .replace(/[^ACGUT]/g, '')
        .replace(/G/g, 'g')
        .replace(/T/g, 'U')
        .replace(/\s/g, '');
};
//# sourceMappingURL=ProKitForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/rna-cish/ProKitForm.js
// module id = 33
// module chunks = 0